export default __webpack_public_path__ + "static/media/mlsbignew.48799c39.png";